import { InlineButton } from "@coherehealth/common";
import { Upload } from "@mui/icons-material";
import React from "react";

const UploadIconButton = (props: React.ComponentProps<typeof InlineButton>) => {
  return (
    <InlineButton {...props} startIcon={<Upload />}>
      {props.children}
    </InlineButton>
  );
};
export default UploadIconButton;
